import httpClient from '../httpClient';

const getSelector = async (query = '') => {
  return await httpClient.get(`/cds_project_selector/${query}`);
};

const getByProjectOrPosition = async (params) => {
  return await httpClient.get('contract_document_search/', {
    params,
  });
};

export { getSelector, getByProjectOrPosition };
